'use client'

import { IconCheck } from '@macarongfactory/web-icons'
import { Divider, Text } from '@macarongfactory/web-ui'

import type { IRankSegment } from '../_features/rank'

/** 체크마크 아이콘 크기(px) */
const CHECK_ICON_SIZE_PX = 24

interface IRankLnbProps {
  segments: IRankSegment[]
  activeSegment: string
  onSelect: (segmentId: string) => void
}

/**
 * 차급 세그먼트 LNB (데스크탑 전용) — Figma 8462:103637
 * 카드형 세로 리스트. 선택 항목은 강조 배경 + SemiBold + 체크마크.
 */
const RankLnb = ({ segments, activeSegment, onSelect }: IRankLnbProps) => {
  return (
    <nav
      className='sticky top-[114px] flex max-h-[calc(100dvh-114px)] w-[280px] shrink-0 flex-col self-start rounded-dimension-x5 border border-stroke-neutral-strong bg-background-surface-default px-dimension-x4 py-dimension-x5'
      aria-label='차급 선택'
    >
      <div className='-mx-dimension-x4 mb-dimension-x1 shrink-0'>
        <Text
          variant='heading-3-bold'
          color='text-foreground-neutral-strong'
          className='px-dimension-x5 pb-dimension-x5'
        >
          차량 모델
        </Text>
        <Divider.Horizontal />
      </div>

      <div className='flex min-h-px flex-col overflow-y-auto'>
        {segments.map(segment => {
          const selected = segment.id === activeSegment
          return (
            <button
              key={segment.id}
              type='button'
              onClick={() => onSelect(segment.id)}
              aria-current={selected ? 'true' : undefined}
              className={`flex w-full items-center gap-dimension-x3 rounded-dimension-x2-5 px-dimension-x5 py-dimension-x4 ${
                selected ? 'bg-background-neutral-weak/50' : ''
              }`}
            >
              <Text
                variant={selected ? 'title-1-semibold' : 'title-1-medium'}
                color={
                  selected
                    ? 'text-foreground-neutral-strong'
                    : 'text-foreground-neutral-normal'
                }
                className='flex-1 text-left'
              >
                {segment.label}
              </Text>
              {selected ? (
                <span className='inline-flex shrink-0 text-foreground-brand-strong'>
                  <IconCheck
                    width={CHECK_ICON_SIZE_PX}
                    height={CHECK_ICON_SIZE_PX}
                  />
                </span>
              ) : (
                <span
                  aria-hidden
                  className='shrink-0'
                  style={{
                    width: CHECK_ICON_SIZE_PX,
                    height: CHECK_ICON_SIZE_PX,
                  }}
                />
              )}
            </button>
          )
        })}
      </div>
    </nav>
  )
}

export default RankLnb
